// utils/recurringDates.js
// Daty faktur cyklicznych trzymamy jako "YYYY-MM-DD" (MySQL DATE) — bez stref czasowych.

export const FREQUENCIES = [
  { value: "MONTHLY", label: "Co miesiąc", months: 1 },
  { value: "QUARTERLY", label: "Co kwartał", months: 3 },
  { value: "HALF_YEARLY", label: "Co pół roku", months: 6 },
  { value: "YEARLY", label: "Co rok", months: 12 },
];

export const frequencyLabel = (value) =>
  FREQUENCIES.find((f) => f.value === value)?.label || value || "-";

const pad = (n) => String(n).padStart(2, "0");

// "YYYY-MM-DD" -> { y, m } (m: 1-12)
const parseYearMonth = (dateStr) => {
  const [y, m] = String(dateStr || "").split("-").map(Number);
  if (!y || !m) return null;
  return { y, m };
};

// ostatni dzień miesiąca: y, m (1-12) -> "YYYY-MM-DD"
export const lastDayOfMonth = (y, m) => {
  const day = new Date(Date.UTC(y, m, 0)).getUTCDate();
  return `${y}-${pad(m)}-${pad(day)}`;
};

// "YYYY-MM" (input type="month") -> ostatni dzień tego miesiąca
export const lastDayFromMonthInput = (monthStr) => {
  const ym = parseYearMonth(monthStr);
  return ym ? lastDayOfMonth(ym.y, ym.m) : "";
};

// "YYYY-MM-DD" -> "YYYY-MM"
export const toMonthInput = (dateStr) => String(dateStr || "").slice(0, 7);

// kolejna data: ostatni dzień miesiąca przesuniętego o okres częstotliwości
export const nextInvoiceDate = (dateStr, frequency) => {
  const ym = parseYearMonth(dateStr);
  const months = FREQUENCIES.find((f) => f.value === frequency)?.months;
  if (!ym || !months) return "";

  const total = ym.y * 12 + (ym.m - 1) + months;
  return lastDayOfMonth(Math.floor(total / 12), (total % 12) + 1);
};

// "YYYY-MM-DD" -> "DD.MM.YYYY"
export const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const [y, m, d] = String(dateStr).slice(0, 10).split("-");
  return `${d}.${m}.${y}`;
};

export const todayStr = () => {
  const now = new Date();
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
};

export const formatAmount = (amount) => {
  const n = Number(amount);
  if (amount === null || amount === undefined || Number.isNaN(n)) return "-";
  return new Intl.NumberFormat("pl-PL", {
    style: "currency",
    currency: "PLN",
  }).format(n);
};
